import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { Layout, LayoutProps } from '@roc/feature-app-core';
import { observer } from 'mobx-react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageLayoutContainer: {
      padding: 0,
    },
  }),
);

interface BorrowerPortalPageLayoutProps extends LayoutProps {
}

export const BorrowerPortalPageLayout = observer(({ children, ...rest }: BorrowerPortalPageLayoutProps) => {
  const classes = useStyles();
  return (
    <Layout containerClass={classes.pageLayoutContainer} {...rest}>
      {children}
    </Layout>
  );
});
